import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { LogCategory, LogCoreService, LoggerService, LogType } from './logger.service';


@Injectable({
    providedIn: 'root'
})
export class SidebarService {

    public content$: BehaviorSubject<{ name:string, title:string }>;
    public status$: BehaviorSubject<string>;

    constructor(        
        private logger: LoggerService,        
    ) {
        this.log("constructor", null, LogCategory.Constructor);
        this.content$ = new BehaviorSubject({name:'', title:''});
        this.status$ = new BehaviorSubject('out');
    }

    private log(method: string = null, message = null, category: LogCategory = LogCategory.Default): void {
        method = (method) ? '.' + method + '()' : '';
        message = (message) ? message.toString() : '';
        this.logger.try(this.constructor.name + method + ': ' + message, LogType.CoreService, LogCoreService.Sidebar, category);
    }

    public openHelp(content) {
        this.content$.next(content);
        this.status$.next('in');
    }

    public closeHelp() {
        this.status$.next('out');
    }

}
